import { EMPTY_LIST } from '../../../constants/common'
import { DATE_FULL_FORMAT_FROM_TIME } from '../../../constants/date'
import { INTEGRATION_CONNECTION_STATUS } from '../../../constants/rentalPortal'
import { PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH } from '../../MultipleViewTypeList'
import { formatDate } from '../../Table'

import {
  INTEGRATION_CONNECT_KIND_BY_PORTAL,
  IntegrationConnectKind,
  INTEGRATIONS_PAYLOAD_FIELD,
} from './RentalPortalIntegrations.constants'

function toIntegrationsRow(portal) {
  return { ...portal, id: portal.portal }
}

function getIsIntegrationConnectionError(status) {
  return status === INTEGRATION_CONNECTION_STATUS.error
}

export function getIntegrationsPortals(integrations) {
  return (integrations?.[INTEGRATIONS_PAYLOAD_FIELD.portals] ?? EMPTY_LIST).map(
    toIntegrationsRow
  )
}

export function getIntegrationsPortalById({ activeItem, portals }) {
  return portals.find(portal => portal.id === activeItem)
}

export function getIntegrationConnectionStatus(portal) {
  if (getIsIntegrationConnectionError(portal.status)) {
    return INTEGRATION_CONNECTION_STATUS.error
  }

  if (portal.needs_reauth) {
    return INTEGRATION_CONNECTION_STATUS.needsReauth
  }

  return portal.connected
    ? INTEGRATION_CONNECTION_STATUS.connected
    : INTEGRATION_CONNECTION_STATUS.notConnected
}

export function getIntegrationLastCheckedLabel({
  lastCheckedAt,
  locale,
  timezone,
}) {
  return lastCheckedAt
    ? formatDate({
        date: lastCheckedAt,
        dateFormat: DATE_FULL_FORMAT_FROM_TIME,
        locale,
        timezone,
        useTodayFormat: false,
      })
    : null
}

export function getIntegrationsCanConfigure(integrations) {
  return Boolean(integrations?.[INTEGRATIONS_PAYLOAD_FIELD.canConfigure])
}

// TODO: read the per-portal toggle from the integrations status once it serves
// one; until then an absent flag means the portal is offered.
export function getIsIntegrationPortalEnabled(connection) {
  return connection.enabled ?? true
}

export function getIntegrationConnectKind(connection) {
  return INTEGRATION_CONNECT_KIND_BY_PORTAL[connection.portal]
}

export function getIsIntegrationConnected(status) {
  return status === INTEGRATION_CONNECTION_STATUS.connected
}

export function getIsIntegrationCredentialConnect(connection) {
  return (
    getIntegrationConnectKind(connection) === IntegrationConnectKind.openimmo
  )
}

export function getIsIntegrationsEmpty({ isLoading, portals }) {
  return !isLoading && portals.length === 0
}

export function getIsIntegrationsSplitAvailable(width) {
  return width >= PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH
}

export function getHasIntegrationConnection(status) {
  return status !== INTEGRATION_CONNECTION_STATUS.notConnected
}
